import { Modal } from 'antd';

let handlers = {
  showRestError: null,
  destroyBlockingUI: null,
};

/**
 * Called once from GlobalFeedbackProvider on mount.
 * @param {object} next
 * @param {(err: import('./restApiError').ApiClientError) => void} [next.showRestError]
 * @param {() => void} [next.destroyBlockingUI]
 */
export function setGlobalFeedbackHandlers(next = {}) {
  handlers = { ...handlers, ...next };
}

export function clearGlobalFeedbackHandlers() {
  handlers = {
    showRestError: null,
    destroyBlockingUI: null,
  };
}

/** antd notification for generic REST failures; no-ops until the provider registers. */
export function showRestError(apiClientError) {
  if (typeof handlers.showRestError === 'function') {
    handlers.showRestError(apiClientError);
  }
}

/** Tear down blocking modals before auth redirect / session handling. */
export function destroyBlockingUI() {
  if (typeof handlers.destroyBlockingUI === 'function') {
    handlers.destroyBlockingUI();
    return;
  }
  Modal.destroyAll();
}
